import { render, staticRenderFns } from "./DepartmentsEditor.vue?vue&type=template&id=0cbc52f5&scoped=true"
import script from "./DepartmentsEditor.vue?vue&type=script&lang=js"
export * from "./DepartmentsEditor.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsEditor.vue?vue&type=style&index=0&id=0cbc52f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc52f5",
  null
  
)

export default component.exports